/**
 * @generated SignedSource<<ae2bb9c7dfce76be3a1a4db9c854aff6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProviderRootQuery$variables = {
  slug: string;
};
export type ProviderRootQuery$data = {
  readonly provider: {
    readonly pages: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly slug: string;
          readonly tabTitle: string;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"Header_provider">;
  } | null;
};
export type ProviderRootQuery = {
  variables: ProviderRootQuery$variables;
  response: ProviderRootQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ],
  "concreteType": "ProviderPageConnection",
  "kind": "LinkedField",
  "name": "pages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProviderPageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProviderPage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "pages(first:10)"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProviderRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Provider",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_provider"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProviderRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Provider",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "cover",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "maxHeight",
                    "value": 256
                  },
                  {
                    "kind": "Literal",
                    "name": "maxWidth",
                    "value": 1290
                  }
                ],
                "kind": "ScalarField",
                "name": "transformedSrc",
                "storageKey": "transformedSrc(maxHeight:256,maxWidth:1290)"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Province",
                "kind": "LinkedField",
                "name": "province",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortName",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxHeight",
                        "value": 128
                      },
                      {
                        "kind": "Literal",
                        "name": "maxWidth",
                        "value": 128
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformedSrc",
                    "storageKey": "transformedSrc(maxHeight:128,maxWidth:128)"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Actor",
            "abstractKey": "__isActor"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "33ef59da0584d37f67e11a2e79699c2d",
    "id": null,
    "metadata": {},
    "name": "ProviderRootQuery",
    "operationKind": "query",
    "text": "query ProviderRootQuery(\n  $slug: String!\n) {\n  provider(slug: $slug) {\n    ...Header_provider\n    pages(first: 10) {\n      edges {\n        node {\n          id\n          slug\n          tabTitle\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment Avatar_actor_1ud6Ea on Actor {\n  __isActor: __typename\n  name\n  avatar {\n    transformedSrc(maxHeight: 128, maxWidth: 128)\n    id\n  }\n}\n\nfragment Header_provider on Provider {\n  ...Avatar_actor_1ud6Ea\n  name\n  cover {\n    transformedSrc(maxHeight: 256, maxWidth: 1290)\n    id\n  }\n  city {\n    name\n    province {\n      shortName\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4297f972b2c7d8fbf6956ed213b137e1";

export default node;
